import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';

// Define a type for the slice state
interface ReportsState {
  data: any;
  error: any;
  loading: boolean;
  oboModal:{
    isModalOpen:boolean,
    selectedOpp:any,
    selectedSOW:any,
    activeTab:string,
  }
}

  const initialState: ReportsState = {
    data: null,
    error: null,
    loading: false,
    oboModal:{
      isModalOpen:false,
      selectedOpp:{},
      selectedSOW:{},
      activeTab:'',
    },  
};

export const fetchOBOReport:any = createAsyncThunk(
  'reports/fetchOBOReport',
  async (params:{
    payload:any
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      
      const response = await axios.post(`workorder/api/obo/getOboDetails`,params.payload,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);

export const getOboDownloadFile:any = createAsyncThunk(
  'reports/getOboDownloadFile',
  async (params:{
    payload?: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true,
        responseType: 'blob',
      };

      const response = await axios.post(`workorder/api/obo/downloadOboReport`,params.payload,axiosConfig);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      const userData = await response;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSOWAgeingReport:any = createAsyncThunk(
  'reports/fetchSOWAgeingReport',
  async (params:{
    payload?:any
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      
      const response = await axios.get(`workorder/api/sowdetails/getSowAgeingReport`,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);

export const getSOWAgeingDownloadFile:any = createAsyncThunk(
  'reports/getSOWAgeingDownloadFile',
  async (_params, {rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      const response = await axios.get(`workorder/api/sowdetails/downloadSowAgeingReport`,axiosConfig);
      if (response.status !== 200) {
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSOWRevenueDownloadFile:any = createAsyncThunk(
  'reports/getSOWRevenueDownloadFile',
  async (_params, {rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      const response = await axios.get(`workorder/api/sowdetails/downloadParentAgainstSowReport`,axiosConfig);
      if (response.status !== 200) {
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const downloadBcpReport:any = createAsyncThunk(
  'reports/downloadBcpReport',
  async (_params, { rejectWithValue }) => {
    try {
      const axiosConfig: AxiosRequestConfig<any> = {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      const response = await axios.get(`batchjobs/api/sowdetails/downloadBcpReport`, axiosConfig);
      if (response.status !== 200) {
        return rejectWithValue('Something went wrong. Please try again later.');
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);

export const fetchSOWRevenueReport:any = createAsyncThunk(
  'reports/fetchSOWRevenueReport',
  async (params:{
    payload?:any
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      
      const response = await axios.get(`workorder/api/sowdetails/getParentAgainstSowReport`,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);

const _reportsSlice:any = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    fetchOBOReport_Request: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOBOReport_Failure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setoboModalDetails: (state, action: PayloadAction<ReportsState['oboModal']>) => {         
      state.oboModal.isModalOpen = action.payload.isModalOpen;
      state.oboModal.selectedSOW = action.payload.selectedSOW;
      state.oboModal.selectedOpp = action.payload.selectedOpp;
      state.oboModal.activeTab = action.payload.activeTab;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOBOReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOBOReport.fulfilled, (state, action) => {
         
        state.data = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOBOReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getOboDownloadFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOboDownloadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getOboDownloadFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSOWAgeingReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSOWAgeingReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSOWAgeingReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getSOWAgeingDownloadFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSOWAgeingDownloadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getSOWAgeingDownloadFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSOWRevenueReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSOWRevenueReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSOWRevenueReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getSOWRevenueDownloadFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSOWRevenueDownloadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getSOWRevenueDownloadFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(downloadBcpReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadBcpReport.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(downloadBcpReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  }
});

export const {fetchOBOReport_Request, fetchOBOReport_Failure,setoboModalDetails } = _reportsSlice.actions;

export default _reportsSlice.reducer;